import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			Tiu akuta angulo pikis ĉiujn. 
			Ajna geometria figuro ricevadis de li riproĉon: la Triangulo – pro anguleco, la Cirklo – pro senanguleco, la Kvadrato – pro la manko de diversflankeco. 
			Oni komencis eĉ timi kaj estimi lin pro lia konstanta neaprobo.
		</p>
		
		<p class="mb-3">
			Tiel venis al la Triangulo gloro kaj respekto; fariĝis li solida, impona, peza – nu, unuvorte, obtuza. 
			Kaj kie jam estas lia iama akreco! 
			Oni nur supozas, pro kio li obtuziĝis: ĉu pro superfluaj gradoj, ĉu simple pro la vivo tia.
		</p>
		`
	)
}

const itemName = {
	esp: 'Akuta angulo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;